module.exports = __webpack_public_path__ + "img/bg_top.7b2cc465.png";